import type { ApiTypes } from '@hyundai/ng-common-lib';

export function setFilterQuery(filter: Partial<ApiTypes.FilterObject>): string {
    return JSON.stringify(filter);
}
